import {
  updateHtzOrderCache,
  useHtzOrderPatchMutation,
  useHtzOrderResetReferenceNumberMutation,
  useHtzOrderShowQuery,
} from "@/services/backend/htz/orders/api/order-api";
import { isImmutable } from "@/services/backend/documents/lib/document-state";
import { ReferenceNumberField } from "@/services/backend/documents/components/reference-number-field";

/**
 * OrderReferenceNumberField edits the reference number of the order. It is
 * disabled once the order is immutable.
 */
export function OrderReferenceNumberField({ orderId }: { orderId: string }) {
  const { data } = useHtzOrderShowQuery({ id: orderId });
  const patchReferenceNumber = useHtzOrderPatchMutation();
  const resetReferenceNumber = useHtzOrderResetReferenceNumberMutation();

  if (!data) {
    return null;
  }

  return (
    <ReferenceNumberField
      data={data}
      updateCache={updateHtzOrderCache}
      patchMutation={patchReferenceNumber}
      resetMutation={resetReferenceNumber}
      disabled={isImmutable(data)}
    />
  );
}
